import { Validator } from '@vista-digital/validator';
import { formEventsValidatorSchema } from '../../../subcomponents/form/form/types/events';
export const customerDetailsFormEventsValidator = Validator.object(formEventsValidatorSchema);
